import React, { useState, useEffect, useRef } from 'react'

import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  InputNumber,
  Space,
  Button,
  Tag,
  Row,
  Col,
  Select,
  Divider,
  useSelect,
  Descriptions,
  Breadcrumb,
  Typography,
} from '@pankod/refine-antd'
import { Spin, Upload, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { useCreateMany, useDeleteMany, useGetIdentity, useMany, useOne, useTable, useUpdate } from '@pankod/refine-core'
import ReactMarkdown from 'react-markdown'
import ReactMde from 'react-mde'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import {
  ICentaConcept,
  ICompetency,
  IExplanationTypes,
  IQuestionGrades,
  IStrand,
  ITNTaxonomy,
  IQuestionReviewerApprover,
  IWorkRequestApprover,
  IParentChildReference,
} from 'interfaces'
import he from 'he'
import 'react-mde/lib/styles/css/react-mde-all.css'
import './style.css'
import {
  IGrade,
  ISubject,
  ITopic,
  IBloomLevel,
  ITeacherLevel,
  IDifficultyLevel,
  IQuestion,
  IQuestionType,
  IWorkRequest,
  IReportTheme,
  ISubTheme,
  ITheme,
  IAspect,
} from 'interfaces'
import { type } from 'os'
import { nhost } from 'utility'
import wr_metadata from 'metadata/workrequests'
import {
  CompletionStatus,
  createMailForFirstApprover,
  createMailForFirstReviewer,
  createMailForSecondApprover,
  createMailForSecondReviewer,
  getWorkRequestStatusCount,
} from 'helpers'
import {
  createMailForApproval,
  createMailForReview,
  createMailForReviewRequireAmending,
  createMailOpenRequireAmending,
  createMailRejectedAtApproval,
  createMailRejectedAtRewiew,
} from 'helpers'
import {
  createLogForApproval,
  createLogForFirstApprover,
  createLogForFirstReviewer,
  createLogForReview,
  createLogForReviewRequireAmending,
  createLogForSecondReviewer,
  createLogOpenRequireAmending,
  createLogRejectedAtApproval,
  createLogRejectedAtRewiew,
  createNotificationForApproval,
  createNotificationForReview,
  createNotificationForReviewRequireAmending,
  createNotificationOpenRequireAmending,
  createNotificationRejectedAtApproval,
  createNotificationRejectedAtRewiew,
  createUserHistory,
} from 'gql/mutations'
import { ReactMdeToolbarCommands } from 'helpers/markdownConfig'
import { useUserContext } from 'context/user'
import { stat } from 'fs'
import sendEmail from 'sendmail'
import { useBloomsLevel, useCompetency, useDifficultyLevels, useGrades } from 'utility/masterData'
import { Editor } from '@tinymce/tinymce-react'
import RichTextEditor from 'components/questions/rich_text_editor'
import SunTextEditor from 'components/questions/sun_text_editor'
import { getReportThemeDataByTopicId } from 'gql/query'
import RichTextRender from 'components/questions/rich_text_render'
import { LanguageSelect } from 'components/common/language_select'
import { checkQuestionIdsAreValid } from 'helpers/question/questionOptionId'

const { TextArea } = Input
type EditQuestionProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
  close: any
  updatePercentage?: any
  source?: any
  customTags?: any
}
type BlobInfo = {
  id: () => string
  name: () => string
  filename: () => string
  blob: () => Blob
  base64: () => string
  blobUri: () => string
  uri: () => string | undefined
}

type ProgressFn = (percent: number) => void

type UploadHandler = (blobInfo: BlobInfo, progress: ProgressFn) => Promise<string>

export const EditQuestion: React.FC<EditQuestionProps> = ({ modalProps, formProps, record, close, updatePercentage, source, customTags }) => {
  const [questionStatus, setQuestionStatus] = useState<string>('')
  const { data: user } = useGetIdentity()
  const { userRole, qcreatorList, qapproverList, qreviewerList, vcreatorList } = useUserContext()
  const [selectedTab, setSelectedTab] = useState<'write' | 'preview'>('write')
  const [selectedOptionTab, setSelectedOptionTab] = useState<string[]>([])
  const [questionType, setQuestionType] = useState('MCQ')
  const [optionType, setOptionType] = useState('Text')
  const [reviewers, setReviewers] = useState<string[]>([])
  const [approvers, setApprovers] = useState<string[]>([])
  const [taxonomyRequired, setTaxonomyRequired] = useState(true)
  const [selectedGrades, setSelectedGrades] = useState([] as any[])
  const [taxonomyfilter, setTaxonomyFilter] = useState<any[]>([])
  const [strandfilter, setStrandFilter] = useState<any[]>([])
  const [subjectFilter, setReportThemeFIlter] = useState<any[]>([])
  const { mutate: createGrades } = useCreateMany<IQuestionGrades>()
  const { mutate: deleteGrades } = useDeleteMany<IQuestionGrades>()
  const { mutate: updateSecondReviewerComments } = useUpdate<IQuestion>()
  const { mutate: updateSecondApproverComments } = useUpdate<IQuestion>()
  const [selectedItems, setSelectedItems] = useState<string>('')
  const [errorOption, setError] = useState<boolean>(false)

  const [secondReviewMandatory, setSecondReviewMandatory] = useState(false)
  const [secondApprovalMandatory, setSecondApprovalMandatory] = useState(false)
  const [secondApproverName, setSeconApproverName] = useState<string>('')
  const [secondReviewerName, setSeconReviewerName] = useState<string>('')
  let isClose: boolean = false
  const option_tags = ['Right Answer', 'Most Wrong', 'Close to Correct']
  const filteredOptions = option_tags?.filter(o => selectedItems !== o)

  const [themeQueryEnabled, seThemeQueryEnabled] = useState<boolean>(false)
  const [subThemeQueryEnabled, setSubThemeQueryEnabled] = useState<boolean>(false)
  const [TopicQueryEnabled, setTopicQueryEnabled] = useState<boolean>(false)
  const [reportThemeQueryEnabled, setReportThemeQueryEnabled] = useState<boolean>(false)
  const [mcqOptionFlagRule, setMcqOptionFlagRule] = useState<boolean>(false)
  const [isOpenCustomTag, setIsOpenCustomTag] = useState<boolean>(true)
  const [saveQuestionLoading, setSaveQuestionLoading] = useState<boolean>(false)

  const editorRef = useRef<Editor>(null)
  const { data: workRequestRecord, refetch } = useOne<IWorkRequest>({
    resource: 'work_requests',
    id: record?.work_request_id,
    metaData: wr_metadata,
    queryOptions: {
      enabled: !!record?.work_request_id,
    },
  })

  useEffect(() => {
    if (questionType === 'MCQ') {
      if (record?.option_details?.length > 0) {
        record?.option_details?.map((item: any) => {
          if (item?.option_flag === 'Right Answer') {
            setSelectedItems('Right Answer')
          }
        })
        // console.log('first---------', record?.option_details)
      }
    }
  }, [questionType, record])
  useEffect(() => {
    let arr: object[] = []
    if (record?.question_grades?.length > 0) {
      record?.question_grades?.map((item: any) => {
        arr.push(item?.id)
      })
      arr = arr.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })
      setSelectedGrades(arr)
    }
  }, [record])
  useEffect(() => {
    if (workRequestRecord?.data) setReviewers(workRequestRecord?.data?.reviewer_ids ?? [])
  }, [workRequestRecord])
  useEffect(() => {
    setError(false)

    if (userRole === 'qcreator') {
      setTaxonomyRequired(false)
    }
  }, [userRole])
  useEffect(() => {
    let arr: string[] = []
    if (workRequestRecord?.data && record) {
      const approverIds = workRequestRecord?.data?.workRequestApprovers?.filter((list: any) => list?.reviewer_id === record?.reviewer_id)
      if (approverIds?.length > 0) {
        approverIds.forEach((elem: any) => {
          if (!arr.includes(elem?.approver_id)) arr.push(elem?.approver_id)
        })
        setApprovers(arr)
      }
    }
  }, [workRequestRecord, record, userRole])

  //file upload start ------------------------------
  const [fileList, setFileList] = useState<any>({})
  const [uploading, setUploading] = useState(false)

  const handleImageUpload = async () => {
    setUploading(true)
    let metadatas: any = []
    for (const property in fileList) {
      const file = fileList[property][0]
      if (file) {
        const { fileMetadata } = await nhost.storage.upload({ file })
        metadatas.push(fileMetadata)
      } else {
        metadatas.push([])
      }
    }
    setUploading(false)
    return metadatas
  }
  //file upload end ---------------------------

  const gradeSelectProps = useGrades(modalProps?.visible)
  const bloomlevelSelectProps = useBloomsLevel(modalProps?.visible)
  const difficultylevelSelectProps = useDifficultyLevels(modalProps?.visible)
  const competencySelectProps = useCompetency(modalProps?.visible)

  // const { data: gradeData } = useMany({ resource: 'grades', ids: record?.grade_ids, metaData: { fields: ['name'] } })
  // const gradeNameArr = gradeData?.data
  const { tableQueryResult: parentChildQuestionReferenceTexts } = useTable<IParentChildReference>({
    queryOptions: { enabled: modalProps?.visible && record && record?.work_request?.request_type === 'PC' },
    resource: 'parent_child_question_reference_data',
    initialPageSize: 1000,
    metaData: { fields: ['id', 'reference_data'] },
    permanentFilter: record?.work_request_id ? [{ field: 'work_request_id', operator: 'eq', value: record?.work_request_id }] : [],
  })
  
  const { selectProps: subjectSelectProps } = useSelect<ISubject>({
    queryOptions: { enabled: themeQueryEnabled && modalProps?.visible },
    resource: 'subjects',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    resource: 'themes',
    queryOptions: { enabled: themeQueryEnabled && modalProps?.visible },
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialFilter: [
      {
        field: 'subject_id',
        operator: 'eq',
        value: record?.subject_id ?? '5d8c5987-c185-4bd6-a5c1-2dae0a69501d',
      },
    ],
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    queryOptions: { enabled: subThemeQueryEnabled && modalProps?.visible },
    metaData: { fields: ['id', 'name', 'theme_id'] },
    initialPageSize: 1000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialFilter: [
      {
        field: 'theme_id',
        operator: 'eq',
        value: record?.theme_id ?? '5d8c5987-c185-4bd6-a5c1-2dae0a69501d',
      },
    ],
  })

  const {
    filters: topicFilters,
    setFilters: setTopicFilters,
    tableQueryResult: topicResult,
    sorter,
  } = useTable<ITopic>({
    resource: 'topics',
    queryOptions: { enabled: TopicQueryEnabled && modalProps?.visible },
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
    initialPageSize: 1000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialFilter: [
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: record?.sub_theme_id ?? '5d8c5987-c185-4bd6-a5c1-2dae0a69501d',
      },
    ],
  })

  const { selectProps: tntaxonomySelectProps, queryResult: tnTaxonomyResult } = useSelect<ITNTaxonomy>({
    queryOptions: { staleTime: 0, enabled: modalProps?.visible },
    resource: 'tn_taxonomys',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      ...(taxonomyfilter ?? []),
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: strandSelectProps, queryResult: strandQueryResult } = useSelect<IStrand>({
    queryOptions: { staleTime: 0, enabled: modalProps?.visible },
    resource: 'strands',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'teacher_level_id', 'taxonomy_id', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      ...(strandfilter ?? []),
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: reportThemeProps } = useSelect<IReportTheme>({
    queryOptions: { staleTime: Infinity },
    resource: 'report_themes',
    defaultValueQueryOptions: { enabled: reportThemeQueryEnabled && modalProps?.visible },
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    filters: subjectFilter,
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const handleSubjectChange = (value: { value: any }) => {
    themeFilters.pop()
    formProps?.form?.setFieldsValue({
      theme_id: '',
      sub_theme_id: '',
      topic_id: '',
    })
    setThemeFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ])
  }

  const handleThemeChange = (value: { value: any }) => {
    subThemeFilters.pop()
    formProps?.form?.setFieldsValue({
      sub_theme_id: '',
      topic_id: '',
    })
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleSubThemeChange = (value: { value: any }) => {
    topicFilters.pop()
    formProps?.form?.setFieldsValue({
      topic_id: '',
    })
    setTopicFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }

  const handleCompetencyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      tn_taxonomy_id: null,
      teacher_level_id: null,
      strand_id: null,
    })
    let data: any = [
      {
        field: 'competency_id',
        operator: 'eq',
        value: value,
      },
    ]
    setTaxonomyFilter(data)
    // setStrandFilter(data)
  }
  const handleTaxonomyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      teacher_level_id: null,
      strand_id: null,
    })
    // let arr: any[] = [...strandfilter.filter(item => item?.field === 'competency_id')]
    // let data: any = {
    //   field: 'taxonomy_id',
    //   operator: 'eq',
    //   value: value,
    // }
    // arr.push(data)
    // setStrandFilter(arr)
    const updateFilter = [
      {
        field: 'competency_id',
        operator: 'eq',
        value: formProps?.form?.getFieldValue('competency_id'),
      },
      {
        field: 'taxonomy_id',
        operator: 'eq',
        value: value,
      },
    ]
    setStrandFilter(updateFilter)
  }

  const handleOptionType = (value: any) => {
    setOptionType(value)
  }
  const handleOptionTabChange = (value: any, key: any) => {
    let arr: string[] = [...selectedOptionTab]
    if (value === 'preview') {
      arr.push(key)
    }
    if (value === 'write') {
      if (arr.includes(key)) {
        arr.splice(arr.indexOf(key), 1)
      }
    }

    setSelectedOptionTab(arr)
  }
  const handleSendBack = async (status: string, type: string) => {
    try {
      setQuestionStatus(status)
      if (type === 'approver') {
        updateSecondReviewerComments({
          resource: 'questions',
          id: record?.id,
          values: {
            second_approver_comments: formProps?.form?.getFieldValue('second_approver_comments'),
            status: status,
          },
        })
        let result = qapproverList.filter((appUser: any) => appUser?.id === record?.approver_id)[0]
        createMailForFirstApprover(record?.question_id, result?.user?.displayName, result?.user?.email)
        createLogForFirstApprover(record?.approver_id, record?.second_approver_id, record?.id)
        // formProps?.form?.submit()
      } else if (type === 'reviewer') {
        updateSecondReviewerComments({
          resource: 'questions',
          id: record?.id,
          values: {
            second_reviewer_comments: formProps?.form?.getFieldValue('second_reviewer_comments'),
            status: status,
          },
        })
        let result = qreviewerList.filter((appUser: any) => appUser?.id === record?.reviewer_id)[0]
        createMailForFirstReviewer(record?.question_id, result?.user?.displayName, result?.user?.email)
        createLogForFirstReviewer(record?.reviewer_id, record?.second_reviewer_id, record?.id)
        // formProps?.form?.submit()
      }
    } catch {}
    close()
  }

  const handleImageUplodFromEditor: UploadHandler = async (blobInfo, progress) => {
    let url = ''
    try {
      const fileName = blobInfo?.filename()
      const blob = blobInfo?.blob()
      const file = new File([blob], fileName)
      const { fileMetadata } = await nhost.storage.upload({ file })
      const fileId = fileMetadata?.id ?? ''
      url = await nhost.storage.getPublicUrl({ fileId })
    } catch (err) {
      console.log({ err })
    }
    return Promise.resolve(url)
  }

  const handleSetFormList = (content: string, key: number, fieldName: string, index: any) => {
    const optionsArr = formProps?.form?.getFieldValue('option_details')
    console.log({ optionsArr })
    if (optionsArr?.[index] === undefined) {
      optionsArr[index] = { [fieldName]: content }
    }
    const formVal = optionsArr?.[index]
    Object.assign(formVal, { ...formVal, [fieldName]: content })
    formProps?.form?.setFieldsValue({ option_details: optionsArr })
  }

  const handleOnFinish = async (status: string) => {
    try {
      const validate = await formProps.form?.validateFields()
      setQuestionStatus(status)
      if (status === 'For Second Review') {
        if (secondReviewerName !== null && secondReviewerName !== undefined && secondReviewerName !== '') {
          setSecondReviewMandatory(false)
          let result = qreviewerList.filter((appUser: any) => appUser?.id === secondReviewerName)[0]

          createMailForSecondReviewer(record?.question_id, result?.displayName, result?.email)
          createLogForSecondReviewer(record?.reviewer_id, secondReviewerName, record?.id)
          formProps?.form?.submit()
        } else {
          setSecondReviewMandatory(true)
        }
      } else if (status === 'For Second Approval') {
        console.log({ secondApproverName })
        if (secondApproverName !== '' && secondApproverName !== null && secondApproverName !== undefined) {
          // alert(1)
          setSecondApprovalMandatory(false)
          let result = qapproverList.filter((appUser: any) => appUser?.id === secondApproverName)[0]

          console.log({ result })

          createMailForSecondApprover(record?.question_id, result?.displayName, result?.email)
          createLogForSecondReviewer(record?.approver_id, secondApproverName, record?.id)
          formProps?.form?.submit()
        } else {
          // alert(2)
          setSecondApprovalMandatory(true)
          // formProps?.form?.
        }
      } else if (status === 'Open (Require Amending)') {
        let creatorDetails = []
        if (workRequestRecord?.data?.request_type === 'Q') {
          creatorDetails = qcreatorList.filter((item: any) => item?.id === record?.creator_id)[0]
        }
        if (workRequestRecord?.data?.request_type === 'V') {
          creatorDetails = vcreatorList.filter((item: any) => item?.id === record?.creator_id)[0]
        }
        record && createNotificationOpenRequireAmending(user?.id, record?.creator_id, workRequestRecord?.data, record?.question_id)
        record && createNotificationOpenRequireAmending(user?.id, record?.creator_id, workRequestRecord?.data, record?.question_id)
        record && createLogOpenRequireAmending(record?.reviewer_id, record?.creator_id, workRequestRecord?.data, record?.id)
        createMailOpenRequireAmending(workRequestRecord?.data, record?.question_id, creatorDetails?.user?.displayName, creatorDetails?.user?.email)
        formProps?.form?.submit()
      } else if (status === 'For Review (Require Amending)') {
        let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === record?.reviewer_id)[0]

        record && createNotificationForReviewRequireAmending(user?.id, record?.reviewer_id, workRequestRecord?.data, record?.question_id)
        record && createNotificationForReviewRequireAmending(user?.id, record?.reviewer_id, workRequestRecord?.data, record?.question_id)
        record && createLogForReviewRequireAmending(record?.approver_id, record?.reviewer_id, workRequestRecord?.data, record?.id)
        createMailForReviewRequireAmending(
          workRequestRecord?.data,
          record?.question_id,
          reviewerDetails?.user?.displayName,
          reviewerDetails?.user?.email
        )
        formProps?.form?.submit()
      } else if (status === 'Rejected at Review') {
        let creatorDetails = []
        if (workRequestRecord?.data?.request_type === 'Q') {
          creatorDetails = qcreatorList.filter((item: any) => item?.id === record?.creator_id)[0]
        }
        if (workRequestRecord?.data?.request_type === 'V') {
          creatorDetails = vcreatorList.filter((item: any) => item?.id === record?.creator_id)[0]
        }
        record && createNotificationRejectedAtRewiew(user?.id, record?.creator_id, workRequestRecord?.data, record?.question_id)
        record && createNotificationRejectedAtRewiew(user?.id, record?.creator_id, workRequestRecord?.data, record?.question_id)
        record && createLogRejectedAtRewiew(record?.reviewer_id, workRequestRecord?.data, record?.id)
        createMailRejectedAtRewiew(workRequestRecord?.data, record?.question_id, creatorDetails?.user?.displayName, creatorDetails?.user?.email)
        formProps?.form?.submit()
      } else if (status === 'Rejected at Approval') {
        let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === record?.reviewer_id)[0]

        record &&
          createNotificationRejectedAtApproval(user?.id, record?.creator_id, record?.reviewer_id, workRequestRecord?.data, record?.question_id)
        record &&
          createNotificationRejectedAtApproval(user?.id, record?.creator_id, record?.reviewer_id, workRequestRecord?.data, record?.question_id)
        record && createLogRejectedAtApproval(record?.approver_id, workRequestRecord?.data, record?.id)
        createMailRejectedAtApproval(workRequestRecord?.data, record?.question_id, reviewerDetails?.user?.displayName, reviewerDetails?.user?.email)
        formProps?.form?.submit()
      }
      let reviewerId: any = null
      let approverId: any = null
      if (userRole === 'qcreator' || userRole === 'variantcreator') {
        if (status === 'For Review') {
          if (record?.reviewer_id !== null && record?.reviewer_id !== '') {
            reviewerId = record?.reviewer_id
          } else {
            if (JSON.stringify(workRequestRecord?.data?.reviewer_ids) !== '[]') {
              // let currentCount = workRequestRecord?.data?.question_reviewer_approver?.length
              // if (currentCount === 0) {
              const { for_review_count, reviewed_count, approved_count, for_approval_count, rejected_count, retired_count } =
                getWorkRequestStatusCount(workRequestRecord?.data)
              const reviewerIndex =
                (for_review_count + reviewed_count + rejected_count + retired_count + approved_count + for_approval_count) % reviewers?.length
              // console.log('reviewerIndex', reviewerIndex)
              reviewerId = workRequestRecord?.data?.reviewer_ids[reviewerIndex]
              // }
            }
          }
        }
      } else if (userRole === 'qreviewer') {
        reviewerId = record?.reviewer_id

        if (status === 'For Approval') {
          if (record?.approver_id !== null && record?.approver_id !== '') {
            approverId = record?.approver_id
          } else {
            // if (record?.reviewer_id === user?.id) {
            if (JSON.stringify(workRequestRecord?.data?.workRequestApprovers) !== '[]') {
              const { for_approval_count, approved_count, rejected_count, retired_count } = getWorkRequestStatusCount(workRequestRecord?.data)
              const approverIndex = (for_approval_count + approved_count + rejected_count + retired_count) % approvers?.length

              approverId = approvers[approverIndex]
              // console.log('approverIndex', approverIndex)
              // }
            }
          }
        }
      } else {
        approverId = record?.approver_id
        reviewerId = record?.reviewer_id
        // console.log('bbbbbbbbbbbbbbbbb', reviewerId, approverId)
      }
      if (
        // questionStatus === 'For Approval' ||
        status === 'For Review' ||
        status === 'Rejected at Review' ||
        status === 'Open (Require Amending'
      ) {
        if (reviewerId) {
          let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === reviewerId)[0]

          createNotificationForReview(user?.id, reviewerId, workRequestRecord?.data, record?.question_id)
            .then(() => createLogForReview(reviewerId, workRequestRecord?.data, record?.id))
            .then(() => getWorkRequestStatusCount(workRequestRecord?.data))

            .then(() =>
              createMailForReview(workRequestRecord?.data, record?.question_id, reviewerDetails?.user?.displayName, reviewerDetails?.user?.email)
            )
        }
      }
      if (status === 'For Approval' || status === 'Published' || status === 'Rejected at Approval' || status === 'For Review (Require Amending)') {
        // refetch()

        if (approverId) {
          let approverDetails = qapproverList.filter((appUser: any) => appUser?.id === approverId)[0]

          createNotificationForApproval(user?.id, approverId, workRequestRecord?.data, record?.question_id)
            .then(() => createLogForApproval(record?.reviewer_id, approverId, workRequestRecord?.data, record?.id))
            .then(() => getWorkRequestStatusCount(workRequestRecord?.data))
            .then(() =>
              createMailForApproval(workRequestRecord?.data, record?.question_id, approverDetails?.user?.displayName, approverDetails?.user?.email)
            )
        }
      }
    } catch (error) {
      // console.log(error)
    }
    formProps?.form?.submit()
    setSeconApproverName('')
    setSeconReviewerName('')
    createUserHistory('questions', status.toLowerCase(), record?.id, user?.id, userRole)
  }

  const handleChangeCustomTag = async (values: any) => {
    if (values.length > 1) {
      setIsOpenCustomTag(false)
    } else {
      setIsOpenCustomTag(true)
    }
  }
  const onFinish = async (values: any) => {
    const validIds = await checkQuestionIdsAreValid(values?.variant_of, values?.transilation_of)
    values.variant_of = values?.variant_of ? Number(values.variant_of) : null
    values.transilation_of = values?.transilation_of ? Number(values.transilation_of) : null
    //at least one option insight is required
    const atleastOneOptionInsightIspresent =
      values?.question_type_id !== 'MCQ'
        ? true
        : values?.option_details?.some(
            (opt: any) =>
              opt.option_flag === "Right Answer" &&
              opt?.option_insight
                ?.replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/g, ' ')
                .trim().length > 0
          ) ?? false
    if (
      validIds &&
      values.title &&
      isOpenCustomTag &&
      (values?.question_type_id !== 'MCQ' || values?.option_details.length === 4) &&
      atleastOneOptionInsightIspresent
    ) {
      const DecodedQuestionTitle = he.decode(values.title)
      values.title = DecodedQuestionTitle
      values.custom_tag = Array.isArray(values.custom_tags) && values.custom_tags.length > 0 ? values.custom_tags[0] : null
      // The form item on the question edit page has been modified to use the name "custom_tags" instead of "custom_tag".
      // This change was made because if the name is the same as in the database for that particular item,
      // it will show the values as the default value. Additionally, if there is any null value, it will also be displayed.
      // To avoid this, the name "custom_tags" is used. When submitting, the value is assigned to "values.custom_tag" and "values.custom_tags" is deleted.
      delete values.custom_tags
      let option_array: any = []
      let is_ra_found = false
      let optionTextsAreUnique = true
      let atleastOneFlag = false
      let reviewerId: any = null
      let approverId: any = null
      if (userRole === 'qcreator' || userRole === 'variantcreator') {
        if (questionStatus === 'For Review') {
          if (record?.reviewer_id !== null && record?.reviewer_id !== '') {
            reviewerId = record?.reviewer_id
          } else {
            if (JSON.stringify(workRequestRecord?.data?.reviewer_ids) !== '[]') {
              // let currentCount = workRequestRecord?.data?.question_reviewer_approver?.length
              // if (currentCount === 0) {
              const { for_review_count, reviewed_count, approved_count, for_approval_count, rejected_count, retired_count } =
                getWorkRequestStatusCount(workRequestRecord?.data)
              const reviewerIndex =
                (for_review_count + reviewed_count + rejected_count + retired_count + approved_count + for_approval_count) % reviewers?.length
              // console.log('reviewerIndex', reviewerIndex)
              reviewerId = workRequestRecord?.data?.reviewer_ids[reviewerIndex]
              // }
            }
          }
        }
      } else if (userRole === 'qreviewer') {
        reviewerId = record?.reviewer_id

        if (questionStatus === 'For Approval') {
          if (record?.approver_id !== null && record?.approver_id !== '') {
            approverId = record?.approver_id
          } else {
            if (JSON.stringify(workRequestRecord?.data?.workRequestApprovers) !== '[]') {
              const { for_approval_count, approved_count, rejected_count, retired_count } = getWorkRequestStatusCount(workRequestRecord?.data)
              const approverIndex = (for_approval_count + approved_count + rejected_count + retired_count) % approvers?.length

              approverId = approvers[approverIndex]
            }
          }
        }
      } else {
        approverId = record?.approver_id
        reviewerId = record?.reviewer_id
      }

      if (questionType === 'MCQ' && values?.option_details?.length > 0) {
        // const found = values.option_details?.findIndex((element: any) => element?.option_flag === 'Right Answer')
        // if (found === -1) {
        //   setError(true)
        //   is_ra_found = false
        // } else {
        //   setError(false)
        //   is_ra_found = true
        // }
        const uniqueOptionTexts = new Set()
        const optionsArray = values?.option_details
        const hasAtleastOneFlag = optionsArray.some((option: any) => option.option_flag === 'Most Wrong' || option.option_flag === 'Close to Correct')
        atleastOneFlag = hasAtleastOneFlag
        values.option_details.forEach((option: any, index: number) => {
          option.option_text = he.decode(option.option_text)
          option.option_flag = option?.option_flag ? option?.option_flag : ''
          if (uniqueOptionTexts.has(option.option_text)) {
            optionTextsAreUnique = false
            return
          } else {
            uniqueOptionTexts.add(option.option_text)
            if (option.option_insight) option.option_insight = he.decode(option.option_insight)
            let newOption = { ...option }
            if (option?.option_text.includes('![image]')) {
              const middle = option?.option_text?.slice(option?.option_text.lastIndexOf('/') + 1, option?.option_text?.length - 1)

              newOption.option_image_id = middle
              newOption.type = 'Image'
            } else if (option?.option_text?.includes('<img')) {
              let imgTagPattern = /<img.*?>/
              let imgTagMatch = option?.option_text?.match(imgTagPattern)
              let imgTagString = imgTagMatch ? imgTagMatch[0] : ''
              let imgSrc = imgTagString.split('"')?.[1] ?? ''
              let imgId = imgSrc?.slice(imgSrc?.lastIndexOf('/') + 1)
              newOption['option_image_id'] = imgId
              newOption['type'] = 'Image'
            } else {
              newOption.type = 'Text'
            }
            const option_uuid = String.fromCharCode(97 + index)
            newOption['option_uuid'] = `${record.question_id}_${option_uuid}`
            option_array.push(newOption)
            if (is_ra_found) {
              return
            }
            if (option?.option_flag === 'Right Answer') {
              is_ra_found = true

              return
            } else {
              is_ra_found = false
            }
          }
        })
      } else if (questionType === 'Match' && values?.option_details?.length > 0) {
        option_array = []
        const uniqueOptionTexts = new Set()
        values.option_details.forEach((option: any, index: number) => {
          let newOption = { ...option }
          if (uniqueOptionTexts.has(option.left_label_text) || uniqueOptionTexts.has(option.right_label_text)) {
            optionTextsAreUnique = false
          } else {
            uniqueOptionTexts.add(option.left_label_text)
            uniqueOptionTexts.add(option.right_label_text)
          }
          // LEFT LABEL
          if (option?.left_label_text.includes('![image]')) {
            let left_middle = option?.left_label_text?.slice(option?.left_label_text.lastIndexOf('/') + 1, option?.left_label_text?.length - 1)
            newOption.left_label_image = left_middle
            newOption.type = 'Image'
          } else if (option?.left_label_text?.includes('<img')) {
            let imgTagPattern = /<img.*?>/
            let imgTagMatch = option?.left_label_text?.match(imgTagPattern)
            let imgTagString = imgTagMatch ? imgTagMatch[0] : ''
            let imgSrc = imgTagString.split('"')?.[1] ?? ''
            let imgId = imgSrc?.slice(imgSrc?.lastIndexOf('/') + 1)
            newOption['left_label_image'] = imgId
            newOption['type'] = 'Image'
          } else {
            newOption['type'] = 'Text'
            newOption['left_label_image'] = null
          }
          //RIGHT LABEL
          if (option?.right_label_text.includes('![image]')) {
            let right_middle = option?.right_label_text?.slice(option?.right_label_text.lastIndexOf('/') + 1, option?.right_label_text?.length - 1)
            newOption.right_label_image = right_middle
            newOption.type = 'Image'
          } else if (option?.right_label_text?.includes('<img')) {
            let imgTagPattern = /<img.*?>/
            let imgTagMatch = option?.right_label_text?.match(imgTagPattern)
            let imgTagString = imgTagMatch ? imgTagMatch[0] : ''
            let imgSrc = imgTagString.split('"')?.[1] ?? ''
            let imgId = imgSrc?.slice(imgSrc?.lastIndexOf('/') + 1)
            newOption['right_label_image'] = imgId
            newOption['type'] = 'Image'
          } else {
            newOption['right_label_image'] = null
          }
          option_array.push(newOption)
        })
      } else if (questionType === 'Fill' && values?.option_details?.length > 0) {
        const uniqueOptionTexts = new Set()
        values?.option_details.forEach((option: any) => {
          option.right_answer = he.decode(option.right_answer)
          if (uniqueOptionTexts.has(option.right_answer)) {
            optionTextsAreUnique = false
            return
          } else {
            uniqueOptionTexts.add(option.right_answer)
          }
        })
      }

      if (option_array?.length > 0 && questionType === 'MCQ') {
        setError(!is_ra_found)
        isClose = !is_ra_found
        // return true
      }

      // if (values?.option_details?.length > 0 && questionType === 'MCQ') {
      //   // alert(1)
      //   const found = values.option_details?.findIndex((element: any) => element?.option_flag === 'Right Answer')

      //   if (found === -1) {
      //     setError(true)
      //     is_ra_found = false
      //   } else {
      //     setError(false)
      //     is_ra_found = true
      //   }
      // }
      // console.log('xxxxxxxx-------', is_ra_found, errorOption)

      // close()

      if (values?.topic_id && record?.topic_id && values?.topic_id !== record?.topic_id) {
        const getReportThemeIdResponse: any = await getReportThemeDataByTopicId(values?.topic_id)
        if (getReportThemeIdResponse && getReportThemeIdResponse.report_themes.length) {
          values.report_theme_id = getReportThemeIdResponse.report_themes[0].id
        } else {
          values.report_theme_id = null
        }
      }

      if (!uploading) {
        if (optionTextsAreUnique) {
          if (questionType === 'MCQ') {
            if (option_array?.length > 0) {
              if (is_ra_found && atleastOneFlag) {
                return (
                  formProps.onFinish &&
                  formProps.onFinish({
                    ...values,
                    option_type: '',
                    option_details: option_array,
                    status: questionStatus,
                    reviewer_id: reviewerId,
                    approver_id: approverId,
                  })
                )
              } else {
                isClose = true
                message.error('You have select atleast one flag and one Right answer')
              }
            } else {
              return (
                formProps.onFinish &&
                formProps.onFinish({
                  ...values,
                  option_type: '',
                  option_details: values?.option_details,
                  status: questionStatus,
                  reviewer_id: reviewerId,
                  approver_id: approverId,
                })
              )
            }
          } else if (questionType === 'Match') {
            return (
              formProps.onFinish &&
              formProps.onFinish({
                ...values,
                option_type: '',
                option_details: option_array,
                status: questionStatus,
                reviewer_id: reviewerId,
                approver_id: approverId,
              })
            )
          } else {
            return (
              formProps.onFinish &&
              formProps.onFinish({
                ...values,
                option_type: '',
                option_details: values?.option_details,
                status: questionStatus,
                reviewer_id: reviewerId,
                approver_id: approverId,
              })
            )
          }
        } else {
          isClose = true
          message.warning("can't upload the question now!. options are duplicated")
        }
      }
    } else {
      message.error(
        values?.question_type_id === 'MCQ' && values?.option_details?.length !== 4
          ? "Can't save question. Options must be 4"
          : values?.variant_of || values?.transilation_of
          ? 'Unable to save the question. Please check if the mentioned question IDs are valid'
          : !atleastOneOptionInsightIspresent
          ? 'Right Answer insight is mandatory. Please add an insight before saving the question'
          : "Can't save the question, Multiple custom tags can't be selected"
      )
    }

    // if (!uploading) {
    //   return (
    //     formProps.onFinish &&
    //     formProps.onFinish({
    //       ...values,
    //       option_details: values.option_type === 'Image' ? image_option_details : values?.option_details,
    //       status: questionStatus,
    //       reviewer_id: reviewerId,
    //       approver_id: approverId,
    //       //  grade_ids:values?.grade_ids.length>0 ? values?.grade_ids: record.grade_ids,
    //     })
    //   )
    // }
  }

  // console.log('xxxxxxxxxxxxx', record, workRequestRecord?.data)
  // const onFinish = async (values: any) => {
  //   let reviewerId: any = null
  //   let approverId: any = null
  //   if (userRole === 'qcreator') {
  //     if (questionStatus === 'For Review') {
  //       if (JSON.stringify(workRequestRecord?.data?.reviewer_ids) !== '[]') {
  //         if (currentCount === 0) {
  //           const { for_review_count } = getWorkRequestStatusCount(workRequestRecord?.data)
  //           let reviewerIndex = (workRequestRecord?.data?.count - for_review_count) % reviewers?.length
  //           console.log('reviewerIndex', reviewerIndex)
  //           reviewerId = workRequestRecord?.data?.reviewer_ids[reviewerIndex]
  //         }
  //       }
  //     }
  //   } else if (userRole === 'qreviewer') {
  //     if (questionStatus === 'For Approval') {
  //       const { for_approval_count } = getWorkRequestStatusCount(workRequestRecord?.data)
  //       if (record?.reviewer_id === user?.id) {
  //         if (JSON.stringify(workRequestRecord?.data?.workRequestApprovers) !== '[]') {
  //           let approverIndex = (workRequestRecord?.data?.count - for_approval_count) % approvers?.length
  //           approverId = approvers[approverIndex]
  //         }
  //       }
  //     }
  //     reviewerId = record?.reviewer_id
  //   } else {
  //     approverId = record?.approver_id
  //     reviewerId = record?.reviewer_id
  //   }
  //   if (
  //     questionStatus === 'For Approval' ||
  //     questionStatus === 'For Review' ||
  //     questionStatus === 'Rejected at Review' ||
  //     questionStatus === 'Open (Require Amending'
  //   ) {
  //     // if (userRole !== 'qapprover') {
  //     //   if (record?.approver_id === null || record?.reviewer_id === null) {
  //     //     if (reviewers && reviewers?.length > 0) {
  //     //       alert(1)
  //     //       const { for_review_count, reviewed_count, approved_count, for_approval_count, rejected_count, retired_count } = getWorkRequestStatusCount(
  //     //         workRequestRecord?.data
  //     //       )
  //     //       const reviewerIndex =
  //     //         (for_review_count + reviewed_count + rejected_count + retired_count + approved_count + for_approval_count) % reviewers?.length
  //     //       console.log('reviewerIndex', reviewerIndex)
  //     //       reviewerId = workRequestRecord?.data?.reviewer_ids[reviewerIndex]

  //     //       console.log('reviewerId', reviewerId, workRequestRecord?.data)
  //     //     }
  //     //     // if (approvers && approvers?.length > 0) {
  //     //     //   // refetch()
  //     //     //   alert(2)
  //     //     //   const { for_approval_count, approved_count, rejected_count, retired_count } = getWorkRequestStatusCount(workRequestRecord?.data)
  //     //     //   const approverIndex = (for_approval_count + approved_count + rejected_count + retired_count) % approvers?.length
  //     //     //   approverId = approvers[approverIndex]
  //     //     // }
  //     //   } else {
  //     //     alert(3)
  //     //     if (record?.reviewer_id !== null) reviewerId = record?.reviewer_id
  //     //     // if (record?.approver_id !== null) approverId = record?.approver_id
  //     //   }
  //     // } else {
  //     //   alert(4)
  //     //   if (record?.reviewer_id !== null) {
  //     //     reviewerId = record?.reviewer_id
  //     //   }
  //     //   // approverId = user?.id
  //     // }
  //     // console.log('approver Id', approverId, user?.id)
  //     if (reviewerId) {
  //       createNotificationForReview(user?.id, reviewerId, workRequestRecord?.data, record?.question_id)
  //         .then(() => createLogForReview(reviewerId, workRequestRecord?.data, record?.id))
  //         .then(() => CompletionStatus(workRequestRecord?.data))
  //         .then(() => createMailForReview(workRequestRecord?.data, record?.question_id))
  //     }
  //   }
  //   if (
  //     questionStatus === 'For Approval' ||
  //     questionStatus === 'Published' ||
  //     questionStatus === 'Rejected at Approval' ||
  //     questionStatus === 'For Review (Require Amending)'
  //   ) {
  //     // refetch()

  //     if (approverId) {
  //       createNotificationForApproval(user?.id, approverId, workRequestRecord?.data, record?.question_id)
  //         .then(() => createLogForApproval(record?.reviewer_id, approverId, workRequestRecord?.data, record?.id))
  //         .then(() => CompletionStatus(workRequestRecord?.data))
  //         .then(() => createMailForApproval(workRequestRecord?.data, record?.question_id))
  //     }
  //   }

  //   let image_option_details: any = []
  //   if (values.option_type === 'Image') {
  //     const metadatas = await handleImageUpload()
  //     values.option_details.forEach((option: any, index: number) => {
  //       let newOption = { ...option }
  //       newOption.option_image_id = metadatas[index]?.id ?? option.option_image_id
  //       newOption.option_image_name = metadatas[index]?.name ?? option.option_image_name
  //       image_option_details.push(newOption)
  //     })
  //   }
  //   setFileList([])

  //   close()
  //   console.log('xxxxxxxxxxxxxxxx', reviewerId, approverId, user?.id)
  //   if (!uploading) {
  //     return (
  //       formProps.onFinish &&
  //       formProps.onFinish({
  //         ...values,
  //         option_details: values.option_type === 'Image' ? image_option_details : values?.option_details,
  //         status: questionStatus,
  //         reviewer_id: reviewerId,
  //         approver_id: approverId,
  //         //  grade_ids:values?.grade_ids.length>0 ? values?.grade_ids: record.grade_ids,
  //       })
  //     )
  //   }
  // }

  useEffect(() => {
    if (record && record.question_type_id) {
      setQuestionType(record.question_type_id)
    }
    if (record && record?.option_details) {
      formProps.form?.setFieldsValue({ options_details: record?.option_details })
    }
  }, [record])
  console.log({ errorOption })
  useEffect(() => {
    if (record) {
      themeFilters.pop()
      let data: any = [
        {
          field: 'subject_id',
          operator: 'eq',
          value: record?.subject_id,
        },
      ]
      setReportThemeFIlter(data)
      // setThemeFilters([
      //   {
      //     field: 'report_theme_id',
      //     operator: 'eq',
      //     value: record?.report_theme_id ?? null,
      //   },
      // ])
      setThemeFilters(data)
      setSubThemeFilters([
        {
          field: 'theme_id',
          operator: 'eq',
          value: record?.theme_id ?? null,
        },
      ])
      setTopicFilters([
        {
          field: 'sub_theme_id',
          operator: 'eq',
          value: record?.sub_theme_id ?? null,
        },
      ])
      setTaxonomyFilter([
        {
          field: 'competency_id',
          operator: 'eq',
          value: record?.competency_id ?? '5d8c5987-c185-4bd6-a5c1-2dae0a69501d',
        },
      ])
      let strandfilter = []
      if (record?.taxonomy_id) {
        strandfilter.push({
          field: 'taxonomy_id',
          operator: 'eq',
          value: record?.taxonomy_id,
        })
      }
      if (record?.competency_id) {
        strandfilter.push({
          field: 'competency_id',
          operator: 'eq',
          value: record?.competency_id,
        })
      }
      if (record?.teacher_level_id) {
        strandfilter.push({
          field: 'teacher_level_id',
          operator: 'eq',
          value: record?.teacher_level_id,
        })
        setStrandFilter(strandfilter)
      }
      setReportThemeQueryEnabled(true)
      setSubThemeQueryEnabled(true)
      seThemeQueryEnabled(true)
      setTopicQueryEnabled(true)
    }
  }, [record])

  useEffect(() => {
    if (record?.status) setQuestionStatus(record?.status)
    if (record?.option_type) setOptionType(record?.option_type)
  }, [record])
  const save = async function* (data: any) {
    const wait = function (time: any) {
      return new Promise<void>((a, r) => {
        setTimeout(() => a(), time)
      })
    }
    var arrayBufferView = new Uint8Array(data)
    var blob = new Blob([arrayBufferView], { type: 'image/jpeg' })
    var file = new File([blob], 'image.jpg')

    const { fileMetadata } = await nhost.storage.upload({ file })
    const publicUrl = nhost.storage.getPublicUrl({ fileId: fileMetadata?.id || '' })

    await wait(2000)
    // yields the URL that should be inserted in the markdown

    yield publicUrl
    await wait(2000)
    return true
  }
  const saveOptions = async function* (data: any) {
    // console.log('first-----', key)
    const wait = function (time: any) {
      return new Promise<void>((a, r) => {
        setTimeout(() => a(), time)
      })
    }
    var arrayBufferView = new Uint8Array(data)
    var blob = new Blob([arrayBufferView], { type: 'image/jpeg' })
    var file = new File([blob], 'image.jpg')
    const { fileMetadata } = await nhost.storage.upload({ file })
    // console.log({ fileMetadata })
    let url = nhost.storage.getPublicUrl({ fileId: fileMetadata?.id || '' })

    await wait(2000)
    // yields the URL that should be inserted in the markdown

    yield url
    await wait(2000)
    return true
  }
  const handleValueChange = (value: any, key: any) => {
    console.log({ value, key })
  }
  // console.log('nnnnnnnnnnn', JSON.stringify(workRequestRecord?.data?.workRequestApprovers)!=='[]')
  const handleOptionTags = (value: string) => {
    if (questionType === 'MCQ') {
      const field = formProps?.form?.getFieldValue('option_details')
      const found = field?.findIndex((element: any) => element?.option_flag === 'Right Answer')
      const foundCC = field?.findIndex((element: any) => element?.option_flag === 'Close to Correct')
      const foundMW = field?.findIndex((element: any) => element?.option_flag === 'Most Wrong')
      setSelectedItems(found === -1 ? '' : 'Right Answer')
      setMcqOptionFlagRule(foundCC === -1 && foundMW === -1 ? true : false)
      console.log(foundCC, ':cc', foundMW, ':mw')
      // if (found === -1) {
      //   setSelectedItems('')
      // } else {
      //   setSelectedItems('Right Answer')
      // }
    }
  }
  const submitOnEnter = (e: React.KeyboardEvent<HTMLFormElement>) => {
    // alert(1)
    // console.log('first', e)
  }
  const handleQuestionType = (value: any) => {
    setQuestionType(value)
  }
  useEffect(() => {
    if (record && record.question_type_id) {
      setQuestionType(record.question_type_id)
    }
  }, [record])
  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    queryOptions: { staleTime: Infinity, enabled: modalProps?.visible },
    resource: 'question_types',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  return (
    <Modal
      {...modalProps}
      title="Edit Question"
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      destroyOnClose
      onCancel={() => {
        setSeconApproverName('')
        setSeconReviewerName('')
        setSecondReviewMandatory(false)
        setSecondApprovalMandatory(false)
        close()
      }}
      style={{ height: '100%', top: 0 }}
    >
      {JSON.stringify(record) !== '{}' && record?.id !== '' ? (
        <>
          <Descriptions size="small" column={1}>
            {userRole !== 'qcreator' && userRole !== 'qreviewer' && userRole !== 'qapprover' ? (
              <Descriptions.Item label="">{<Tag color="blue">{record?.status}</Tag>}</Descriptions.Item>
            ) : null}
            <Descriptions.Item label="Work Request">{record?.work_request?.name}</Descriptions.Item>
            {record?.work_request?.request_type && (
              <Descriptions.Item label="Request Type">{`${record?.work_request?.request_type === 'Q' ? 'Normal' : 'Variant'}`}</Descriptions.Item>
            )}
          </Descriptions>

          <Descriptions size="small" column={3}>
            {/* {record?.subject?.name && <Descriptions.Item label="Subject">{record?.subject?.name}</Descriptions.Item>} */}
            {(userRole === 'qreviewer' ||
              userRole === 'qapprover' ||
              userRole === 'qcreator' ||
              userRole === 'variantcreator' ||
              userRole === 'subjectincharge') && (
              <Descriptions.Item label="Grade">
                {record?.work_request?.workRequestGrades?.length > 0 &&
                  record?.work_request?.workRequestGrades?.map((item: any) => <Tag key={item?.grade_id}>{item?.grade?.name}</Tag>)}
              </Descriptions.Item>
            )}
            {JSON.stringify(record?.work_request) !== '{}'
              ? (userRole === 'qcreator' ||
                  userRole === 'variantcreator' ||
                  userRole === 'qreviewer' ||
                  userRole === 'qapprover' ||
                  userRole === 'subjectincharge') && (
                  <>
                    {record?.subject?.name && (
                      <Descriptions.Item label="Subject">{record?.subject?.name || record?.work_request?.subject?.name}</Descriptions.Item>
                    )}
                    {/* {record?.report_theme?.name && (
                      <Descriptions.Item label="Report Theme (TN_Term_Month)">{record?.work_request?.report_theme?.name}</Descriptions.Item>
                    )} */}
                    {record?.theme?.name && (
                      <Descriptions.Item label="Theme">{record?.theme?.name || record?.work_request?.theme?.name}</Descriptions.Item>
                    )}
                    {record?.sub_theme?.name && (
                      <Descriptions.Item label="Sub Theme">{record?.sub_theme?.name || record?.work_request?.sub_theme?.name}</Descriptions.Item>
                    )}
                    {record?.topic?.name && (
                      <Descriptions.Item label="Topic(TN Taxonomy ID/s)">
                        {record?.topic?.name || record?.work_request?.topic?.name}
                      </Descriptions.Item>
                    )}
                    {record?.work_request?.question_type?.name && (
                      <Descriptions.Item label="Question Type">{record?.work_request?.question_type?.name}</Descriptions.Item>
                    )}
                  </>
                )
              : null}
          </Descriptions>
          <Divider style={{ margin: '4px 0' }} />
          <b>Tags:</b>

          {JSON.stringify(record?.work_request) !== '{}'
            ? (userRole === 'qcreator' ||
                userRole === 'variantcreator' ||
                userRole === 'qreviewer' ||
                userRole === 'qapprover' ||
                userRole === 'subjectincharge') && (
                <>
                  <Descriptions size="small" column={2}>
                    {record?.competencies?.name && (
                      <Descriptions.Item label="Competency">
                        {record?.competencies?.name || record?.work_request?.competencies?.name}
                      </Descriptions.Item>
                    )}
                    {record?.taxonomy?.name && (
                      <Descriptions.Item label="Taxonomy">{record?.taxonomy?.name || record?.work_request?.taxonomy?.name}</Descriptions.Item>
                    )}
                    {record?.work_request?.teacher_level?.name && (
                      <Descriptions.Item label="Teacher Level">{record?.work_request?.teacher_level?.name}</Descriptions.Item>
                    )}
                    {record?.strands?.name && (
                      <Descriptions.Item label="Standard">{record?.strands?.name || record?.work_request?.strands?.name}</Descriptions.Item>
                    )}
                    {record?.bloom_level?.name && (
                      <Descriptions.Item label="Bloom Level">
                        {record?.bloom_level?.name || record?.work_request?.bloom_level?.name}
                      </Descriptions.Item>
                    )}
                    {record?.difficulty_level?.name && (
                      <Descriptions.Item label="Difficulty">
                        {record?.difficulty_level?.name || record?.work_request?.difficulty_levels?.name}
                      </Descriptions.Item>
                    )}

                    {record?.work_request?.centa_concept?.name && (
                      <Descriptions.Item label="Centa Concept">{record?.work_request?.centa_concept?.name}</Descriptions.Item>
                    )}
                  </Descriptions>
                </>
              )
            : null}
        </>
      ) : null}
      <Form
        // onKeyDown={e => submitOnEnter(e)}
        {...formProps}
        layout="vertical"
        onFinish={values => {
          setSaveQuestionLoading(true)
          onFinish(values)
            .then((res: any) => {
              let grade_array: object[] = []
              if (values?.grade_ids?.length > 0) {
                values?.grade_ids?.map((item: any) => {
                  grade_array.push({
                    grade_id: item,
                    question_id: record?.id,
                  })
                })
                if (selectedGrades?.length > 0) {
                  deleteGrades({
                    resource: 'question_grades',
                    ids: selectedGrades,
                  })
                }
                // deleteWorkRequestGrades(record?.id).then((resp: any) => {
                createGrades({
                  resource: 'question_grades',
                  values: grade_array,
                })
                // })
              }
              setSelectedItems('')

              createUserHistory('questions', 'edit', record?.id, user?.id, userRole)

              setFileList([])
              if (source !== 'questions_show') {
                updatePercentage()
              }

              if (res?.data && isClose === false) {
                close()
                return res?.data
              }
            })
            .then((res: any) => {
              if (res && isClose === false) {
                setIsOpenCustomTag(true)
                console.log('Call came Second')
                close()
                isClose = false
              }
              setSaveQuestionLoading(false)
              // console.log('haiiiiiiiiiiiiiii', errorOption, isClose)
            })
        }}
      >
        <Row gutter={[16, 0]}>
          {userRole === 'qcreator' || userRole === 'subjectincharge' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Question Type" name="question_type_id" rules={[{ required: true }]}>
                <Select onChange={handleQuestionType} {...questionTypeSelectProps} placeholder="Select Question Type" />
              </Form.Item>
            </Col>
          ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Question Type" name="question_type_id" rules={[{ required: true }]}>
                <Select onChange={handleQuestionType} {...questionTypeSelectProps} placeholder="Select Question Type" />
              </Form.Item>
            </Col>
          ) : null}
          {(userRole === 'qcreator' || userRole === 'subjectincharge') && record?.work_request_id && record?.work_request?.request_type === 'PC' && (
            <Col xs={24} lg={8}>
              <Form.Item label="Reference Texts" name="reference_data_id" rules={[{ required: true }]}>
                <Select onChange={value => console.log(value, 'Value')} allowClear showSearch>
                  {parentChildQuestionReferenceTexts?.data?.data?.map(item => (
                    <option key={item.id} value={item.id}>
                      <RichTextRender content={item?.reference_data} key={item?.id} styles={{ width: 'max', height: '50px' }} />
                    </option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}

          {(userRole !== 'qreviewer' && userRole !== 'qapprover' && record?.work_request?.workRequestGrades?.length <= 0) ||
          userRole === 'subjectincharge' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Grade" name="grade_ids" rules={[{ required: true }]}>
                <Select {...gradeSelectProps} mode="multiple" showSearch={false} />
                {/* {gradeNameArr?.length ? gradeNameArr?.map(({ name }) => <Tag>{name}</Tag>) : <></>} */}
              </Form.Item>
            </Col>
          ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Grade" name="grade_ids" rules={[{ required: true }]}>
                <Select {...gradeSelectProps} mode="multiple" showSearch={false} />
                {/* {gradeNameArr?.length ? gradeNameArr?.map(({ name }) => <Tag>{name}</Tag>) : <></>} */}
              </Form.Item>
            </Col>
          ) : null}

          {/* {userRole !== 'qreviewer' &&
            userRole !== 'qapprover' &&
            (JSON.stringify(workRequestRecord?.data) === '{}' ||
            workRequestRecord?.data?.report_theme_id === '' ||
            workRequestRecord?.data?.report_theme_id === null ? (
              <Col xs={24} lg={8}>
                <Form.Item label="Report Theme (TN_Term_Month)" name="report_theme_id" rules={[{ required: true }]}>
                  <Select {...reportThemeProps} showSearch onChange={handleReportThemeChange} allowClear />
                </Form.Item>
              </Col>
            ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
              <Col xs={24} lg={8}>
                <Form.Item label="Report Theme (TN_Term_Month)" name="report_theme_id" rules={[{ required: true }]}>
                  <Select {...reportThemeProps} onChange={handleReportThemeChange} allowClear />
                </Form.Item>
              </Col>
            ) : null)} */}
          
          {userRole === 'subjectincharge' && (
            <Col xs={24} lg={8}>
              <Form.Item label="Subject" name="subject_id" rules={[{ required: true }]}>
                <Select onChange={handleSubjectChange} {...subjectSelectProps} placeholder="Select Subject" />
              </Form.Item>
            </Col>
          )}

          {userRole !== 'qreviewer' &&
            userRole !== 'qapprover' &&
            (JSON.stringify(workRequestRecord?.data) === '{}' ||
            workRequestRecord?.data?.theme_id === '' ||
            workRequestRecord?.data?.theme_id === null ||
            userRole === 'subjectincharge' ? (
              <Col xs={24} lg={8}>
                <Form.Item label="Theme" name="theme_id" rules={[{ required: true }]}>
                  <Select
                    onChange={handleThemeChange}
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                      option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    allowClear
                    // disabled={
                    //   formProps?.form?.getFieldValue('report_theme_id') === undefined || formProps?.form?.getFieldValue('report_theme_id') == null
                    //     ? true
                    //     : false
                    // }
                  >
                    {themeResult?.data?.data?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
              <Col xs={24} lg={8}>
                <Form.Item label="Theme" name="theme_id" rules={[{ required: true }]}>
                  <Select
                    onChange={handleThemeChange}
                    allowClear
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                      option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    // disabled={
                    //   formProps?.form?.getFieldValue('report_theme_id') === undefined || formProps?.form?.getFieldValue('report_theme_id') == null
                    //     ? true
                    //     : false
                    // }
                  >
                    {themeResult?.data?.data?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            ) : null)}
          {/* ) : null} */}
          {/* {JSON.stringify(record) === "{}" || record?.sub_theme_id === "" || record?.sub_theme_id === null ? ( */}
          {userRole !== 'qreviewer' &&
            userRole !== 'qapprover' &&
            (JSON.stringify(workRequestRecord?.data) === '{}' ||
            workRequestRecord?.data?.sub_theme_id === '' ||
            workRequestRecord?.data?.sub_theme_id === null ||
            userRole === 'subjectincharge' ? (
              <Col xs={24} lg={8}>
                <Form.Item label="Sub-theme" name="sub_theme_id" rules={[{ required: true }]}>
                  <Select
                    onChange={handleSubThemeChange}
                    allowClear
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                      option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={
                      formProps?.form?.getFieldValue('theme_id') === undefined || formProps?.form?.getFieldValue('theme_id') == null ? true : false
                    }
                  >
                    {subThemeResult?.data?.data?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
              <Col xs={24} lg={8}>
                <Form.Item label="Sub-theme" name="sub_theme_id" rules={[{ required: true }]}>
                  <Select
                    onChange={handleSubThemeChange}
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                      option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    allowClear
                    disabled={
                      formProps?.form?.getFieldValue('theme_id') === undefined || formProps?.form?.getFieldValue('theme_id') == null ? true : false
                    }
                  >
                    {subThemeResult?.data?.data?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            ) : null)}
          {/* ) : null} */}
          {/* {JSON.stringify(record) === "{}" || record?.topic_id === "" || record?.topic_id === null ? ( */}
          {userRole !== 'qreviewer' &&
            userRole !== 'qapprover' &&
            (JSON.stringify(workRequestRecord?.data) === '{}' ||
            workRequestRecord?.data?.topic_id === '' ||
            workRequestRecord?.data?.topic_id === null ||
            userRole === 'subjectincharge' ? (
              <Col xs={24} lg={8}>
                <Form.Item label="Topic" name="topic_id" rules={[{ required: true }]}>
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                      option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={
                      formProps?.form?.getFieldValue('sub_theme_id') === undefined ||
                      formProps?.form?.getFieldValue('sub_theme_id') == null ||
                      formProps?.form?.getFieldValue('sub_theme_id') === ''
                        ? true
                        : false
                    }
                  >
                    {topicResult?.data?.data?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
              <Col xs={24} lg={8}>
                <Form.Item label="Topic" name="topic_id" rules={[{ required: true }]}>
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                      option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={
                      formProps?.form?.getFieldValue('sub_theme_id') === undefined || formProps?.form?.getFieldValue('sub_theme_id') == null
                        ? true
                        : false
                    }
                  >
                    {topicResult?.data?.data?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            ) : null)}
          {/* ------------competency */}
          {JSON.stringify(workRequestRecord?.data) === '{}' ||
          workRequestRecord?.data?.competency_id === '' ||
          workRequestRecord?.data?.competency_id === null ||
          userRole === 'subjectincharge' ? (
            <Col xs={24} lg={8}>
              <Form.Item
                label="Competency"
                name="competency_id"
                rules={[{ required: (record?.request_type === 'Uploaded' && userRole === 'qreviewer') || userRole === 'qapprover' ? false : true }]}
              >
                <Select
                  onChange={handleCompetencyChange}
                  {...competencySelectProps}
                  allowClear
                  disabled={userRole === 'qreviewer' || userRole === 'qapprover'}
                />
              </Form.Item>
            </Col>
          ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
            <Col xs={24} lg={8}>
              <Form.Item
                label="Competency"
                name="competency_id"
                rules={[{ required: (record?.request_type === 'Uploaded' && userRole === 'qreviewer') || userRole === 'qapprover' ? false : true }]}
              >
                <Select
                  onChange={handleCompetencyChange}
                  {...competencySelectProps}
                  allowClear
                  disabled={userRole === 'qreviewer' || userRole === 'qapprover'}
                />
              </Form.Item>
            </Col>
          ) : null}
          {/* --------------------Taxonomy */}
          {JSON.stringify(workRequestRecord?.data) === '{}' ||
          workRequestRecord?.data?.taxonomy_id === '' ||
          workRequestRecord?.data?.taxonomy_id === null ||
          userRole === 'subjectincharge' ? (
            <Col xs={24} lg={8}>
              <Form.Item
                label="Taxonomy"
                name="tn_taxonomy_id"
                rules={[
                  {
                    required:
                      (record?.request_type === 'Uploaded' && userRole === 'qreviewer') || userRole === 'qapprover' ? false : taxonomyRequired,
                  },
                ]}
              >
                <Select
                  allowClear
                  disabled={
                    formProps?.form?.getFieldValue('competency_id') === undefined || formProps?.form?.getFieldValue('competency_id') == null
                      ? true
                      : false || userRole === 'qreviewer' || userRole === 'qapprover'
                  }
                  onChange={handleTaxonomyChange}
                  {...tntaxonomySelectProps}
                />
              </Form.Item>
            </Col>
          ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Taxonomy" name="tn_taxonomy_id" rules={[{ required: taxonomyRequired }]}>
                <Select
                  key={formProps?.form?.getFieldValue('competency_id') || 'no-competency'}
                  loading={tnTaxonomyResult.isFetching}
                  disabled={
                    formProps?.form?.getFieldValue('competency_id') === undefined || formProps?.form?.getFieldValue('competency_id') == null
                      ? true
                      : false || userRole === 'qreviewer' || userRole === 'qapprover'
                  }
                  allowClear
                  onChange={handleTaxonomyChange}
                  {...tntaxonomySelectProps}
                />
              </Form.Item>
            </Col>
          ) : null}
          {/* ------------Standard------------- */}
          {JSON.stringify(workRequestRecord?.data) === '{}' ||
          workRequestRecord?.data?.strand_id === '' ||
          workRequestRecord?.data?.strand_id === null ||
          userRole === 'subjectincharge' ? (
            <Col xs={24} lg={8}>
              <Form.Item
                label="Standard"
                name="strand_id"
                rules={[{ required: (record?.request_type === 'Uploaded' && userRole === 'qreviewer') || userRole === 'qapprover' ? false : true }]}
              >
                <Select
                  key={formProps?.form?.getFieldValue('tn_taxonomy_id') || 'no-tn_taxonomy_id'}
                  {...strandSelectProps}
                  loading={strandQueryResult?.isFetching}
                  allowClear
                  disabled={
                    formProps?.form?.getFieldValue('tn_taxonomy_id') === undefined || formProps?.form?.getFieldValue('tn_taxonomy_id') == null
                      ? true
                      : false || userRole === 'qreviewer' || userRole === 'qapprover'
                  }
                />
              </Form.Item>
            </Col>
          ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Standard" name="strand_id" rules={[{ required: true }]}>
                <Select
                  {...strandSelectProps}
                  // disabled={
                  //   formProps?.form?.getFieldValue('tn_taxonomy_id') === undefined || formProps?.form?.getFieldValue('tn_taxonomy_id') == null
                  //     ? true
                  //     : false ||
                  //       (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                  //       (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                  // }
                  allowClear
                />
              </Form.Item>
            </Col>
          ) : null}
          {JSON.stringify(workRequestRecord?.data) === '{}' ||
          workRequestRecord?.data?.bloom_level_id === '' ||
          workRequestRecord?.data?.bloom_level_id === null ||
          userRole === 'subjectincharge' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the appropriate Bloom's taxonomy level" name="bloom_level_id" rules={[{ required: true }]}>
                <Select {...bloomlevelSelectProps} disabled={userRole === 'qreviewer' || userRole === 'qapprover'} />
              </Form.Item>
            </Col>
          ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the appropriate Bloom's taxonomy level" name="bloom_level_id" rules={[{ required: true }]}>
                <Select {...bloomlevelSelectProps} disabled={userRole === 'qreviewer' || userRole === 'qapprover'} />
              </Form.Item>
            </Col>
          ) : null}
          {JSON.stringify(workRequestRecord?.data) === '{}' ||
          workRequestRecord?.data?.difficulty_level_id === '' ||
          workRequestRecord?.data?.difficulty_level_id === null ||
          userRole === 'subjectincharge' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the appropriate difficulty level" name="difficulty_level_id" rules={[{ required: true }]}>
                <Select {...difficultylevelSelectProps} disabled={userRole === 'qreviewer' || userRole === 'qapprover'} />
              </Form.Item>
            </Col>
          ) : JSON.stringify(record) === '{}' || record?.request_type === 'Uploaded' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the appropriate difficulty level" name="difficulty_level_id" rules={[{ required: true }]}>
                <Select
                  {...difficultylevelSelectProps}
                  disabled={
                    (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                    (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                  }
                />
              </Form.Item>
            </Col>
          ) : null}

          <Col xs={24} lg={8}>
            <Form.Item label="Custom tag" name="custom_tags" rules={[{ required: false }]}>
              <Select
                mode="tags"
                maxLength={1}
                options={customTags}
                defaultValue={record?.custom_tag !== null ? record?.custom_tag : []}
                onChange={handleChangeCustomTag}
                allowClear
              />
            </Form.Item>
            {!isOpenCustomTag && <p style={{ color: 'red' }}>Can't select multiple custom tags</p>}
          </Col>
          {/* language */}
          <Col xs={24} lg={8}>
            <Form.Item initialValue={'english'} label="Language" name="language" rules={[{ required: true }]}>
              <LanguageSelect />
            </Form.Item>
          </Col>
          {/* variant of*/}
          <Col xs={24} lg={8}>
            <Form.Item label="Variant Of (Question ID)" name="variant_of" rules={[{ required: false }]}>
              <Input type="number" allowClear />
            </Form.Item>
          </Col>
          {/* transilation of */}
          <Col xs={24} lg={8}>
            <Form.Item label="Translated From (Question ID)" name="transilation_of" rules={[{ required: false }]}>
              <Input type="number" allowClear />
            </Form.Item>
          </Col>

          <Form.Item name="updated_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Question Details
            </Divider>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Form.Item
              label="Question"
              name="title"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <>
                {/* ------------------TINCY_MCE TEXT EDITOR----------------- */}
                {/* <RichTextEditor
                  id="question_title_edit"
                  initialValue={record?.title}
                  formValueSetterFn={(content: string) => {
                    formProps?.form?.setFieldsValue({ title: content })
                  }}
                  // handleImageUpload={handleImageUplodFromEditor}
                /> */}

                {/*-------------------- SUN_TEXT_EDITOR------------------- */}
                <SunTextEditor
                  id="question_title_edit"
                  initialValue={record?.title}
                  formValueSetterFn={(content: string) => {
                    formProps?.form?.setFieldsValue({ title: content })
                  }}
                />
              </>
            </Form.Item>
            <Col xs={24} lg={18}>
              <Form.Item label="Question Insight" name={'question_insight'} rules={[{ required: false }]}>
                {/* <TextArea rows={4} placeholder="Question Insight" disabled={userRole === 'qreviewer' || userRole === 'qapprover'} /> */}
                <>
                  {/* ------------------TINCY_MCE TEXT EDITOR----------------- */}
                  {/* <RichTextEditor
                    id="question_insight_edit"
                    hideToolBarAndMenu={userRole === 'qreviewer' || userRole === 'qapprover'}
                    initialValue={record?.question_insight}
                    formValueSetterFn={(content: string) => {
                      formProps?.form?.setFieldsValue({ question_insight: content })
                    }}
                  /> */}
                  {/*-------------------- SUN_TEXT_EDITOR------------------- */}
                  <SunTextEditor
                    id="question_insight_edit"
                    hideToolBar={userRole === 'qreviewer' || userRole === 'qapprover'}
                    initialValue={record?.question_insight}
                    formValueSetterFn={(content: string) => {
                      formProps?.form?.setFieldsValue({ question_insight: content })
                    }}
                  />
                </>
              </Form.Item>
            </Col>
            {userRole === 'qreviewer' && (
              <Form.Item name="reviewer_stem_comments" rules={[{ required: false }]}>
                <TextArea
                  rows={3}
                  placeholder="Reviewer Stem Comments"
                  disabled={userRole === 'qreviewer' && user?.id === record?.second_reviewer_id}
                />
              </Form.Item>
            )}
            {userRole === 'qreviewer' && (
              <Form.Item name="second_reviewer_comments" label="Second Reviewer Comments" rules={[{ required: false }]}>
                <TextArea
                  rows={3}
                  placeholder=" Second Reviewer Stem Comments"
                  disabled={userRole === 'qreviewer' && user?.id === record?.reviewer_id}
                />
              </Form.Item>
            )}
            {userRole === 'qapprover' && (
              <Form.Item name="second_approver_comments" label="Second Approver Comments" rules={[{ required: false }]}>
                <TextArea
                  rows={3}
                  placeholder=" Second Approver Stem Comments"
                  disabled={userRole === 'qapprover' && user?.id === record?.approver_id}
                />
              </Form.Item>
            )}
            {userRole === 'qapprover' && (
              <Form.Item name="approver_stem_comments" rules={[{ required: false }]}>
                <TextArea
                  rows={3}
                  placeholder="Approver Stem Comments"
                  disabled={userRole === 'qapprover' && user?.id === record?.second_approver_id}
                />
              </Form.Item>
            )}
          </Col>
          {questionType === 'ShortAnswer' && (
            <Col xs={24} lg={24}>
              <Form.Item label="Expected points in the answer" name="description">
                <Input />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              {questionType === 'ShortAnswer' && 'Rubric Details'}
              {questionType === 'MCQ' && 'Option Details'}
              {questionType === 'Match' && 'Label Details'}
              {questionType === 'Fill' && 'Answer Details'}
            </Divider>
          </Col>
          {/* {questionType === ('MCQ' || 'Match') && role !== 'qreviewer' && role !== 'qapprover' && ( */}
          {/* {questionType === 'MCQ' && userRole !== 'qreviewer' && userRole !== 'qapprover' && (
            <Col xs={24} lg={12}>
              <Form.Item label="Options Type" name="option_type" initialValue={'Text'}>
                <Select
                  onChange={handleOptionType}
                  options={[
                    { label: 'Text', value: 'Text' },
                    { label: 'Image', value: 'Image' },
                  ]}
                />
              </Form.Item>
            </Col>
          )} */}
        </Row>
        {questionType === 'MCQ' && (
          <Form.List name="option_details">
            {(fields, { add, remove }) => {
              if (Object.keys(fileList)?.length === 0 && fields?.length > 0) {
                let arr: any = {}
                for (let i = 0; i < fields?.length; i++) {
                  arr[i] = []
                }
                setFileList(arr)
              }
              {
                // console.log('fileList', record?.option_details)
              }
              return (
                <>
                  {fields.map(({ key, name, ...restField }, index) => {
                    return (
                      <Row key={key} gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                        <Col lg={10}>
                          <Form.Item
                            {...restField}
                            label="Option Text"
                            name={[name, 'option_text']}
                            rules={[{ required: true, message: 'Missing Option Value' }]}
                          >
                            {/*------------- ALLREADY COMMENT EDITOR----------- */}
                            {/* <ReactMde
                              readOnly={
                                (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                                (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                              }
                              selectedTab={selectedOptionTab?.includes('mcq_' + key) ? 'preview' : 'write'}
                              onTabChange={(value: any) => handleOptionTabChange(value, 'mcq_' + key)}
                              maxEditorHeight={85}
                              onChange={value => handleValueChange(value, key)}
                              generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                              toolbarCommands={ReactMdeToolbarCommands}
                              paste={{
                                saveImage: saveOptions,
                              }}
                            /> */}
                            <>
                              {/* ------------------TINCY_MCE TEXT EDITOR----------------- */}
                              {/* <RichTextEditor
                                id={`${name}option_text`}
                                hideToolBarAndMenu={
                                  (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                                  (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                                }
                                initialValue={record?.option_details?.[key]?.['option_text'] ?? ''}
                                formValueSetterFn={(content: string) => {
                                  handleSetFormList(content, key, 'option_text', index)
                                }}
                                // handleImageUpload={handleImageUplodFromEditor}      
                              /> */}
                              {/*-------------------- SUN_TEXT_EDITOR------------------- */}
                              <SunTextEditor
                                id={`${name}option_text`}
                                hideToolBar={
                                  (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                                  (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                                }
                                initialValue={record?.option_details?.[key]?.['option_text'] ?? ''}
                                formValueSetterFn={(content: string) => {
                                  handleSetFormList(content, key, 'option_text', index)
                                }}
                              />
                            </>
                          </Form.Item>
                        </Col>
                        <Col lg={8}>
                          <Form.Item {...restField} label="Option Insight" name={[name, 'option_insight']} rules={[{ required: false }]}>
                            {/* <TextArea
                              rows={7}
                              placeholder="Option Insight"
                              disabled={
                                (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                                (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                              }
                            /> */}
                            <>
                              {/* ------------------TINCY_MCE TEXT EDITOR----------------- */}
                              {/* <RichTextEditor
                                id={`${name}option_insight`}
                                hideToolBarAndMenu={
                                  (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                                  (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                                }
                                initialValue={record?.option_details?.[key]?.['option_insight'] ?? ''}
                                formValueSetterFn={(content: string) => {
                                  handleSetFormList(content, key, 'option_insight', index)
                                }}
                                // handleImageUpload={handleImageUplodFromEditor}
                              /> */}
                              {/*-------------------- SUN_TEXT_EDITOR------------------- */}
                              <SunTextEditor
                                id={`${name}option_insight`}
                                hideToolBar={
                                  (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                                  (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                                }
                                initialValue={record?.option_details?.[key]?.['option_insight'] ?? ''}
                                formValueSetterFn={(content: string) => {
                                  handleSetFormList(content, key, 'option_insight', index)
                                }}
                              />
                            </>
                          </Form.Item>
                        </Col>
                        <Col lg={3}>
                          <Form.Item
                            {...restField}
                            name={[name, 'option_flag']}
                            rules={[{ required: mcqOptionFlagRule ? true : false, message: 'Missing Option Flag' }]}
                          >
                            <Select
                              placeholder="Option Flag"
                              style={{ width: 150 }}
                              disabled={
                                (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                                (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                              }
                              // value={selectedItems}
                              onChange={handleOptionTags}
                              // onDeselect={handleDeselectOptionTags}
                              allowClear
                              options={filteredOptions.map(item => ({
                                value: item,
                                label: item,
                              }))}
                            />
                          </Form.Item>{' '}
                        </Col>
                        {/* for option uuid--------------- */}
                        {/* <Form.Item>
                          <Input></Input>
                        </Form.Item> */}
                        {userRole === 'qreviewer' && (
                          <Col lg={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'reviewer_comments']}
                              rules={[{ required: false, message: 'Missing Option Comments' }]}
                            >
                              <TextArea
                                rows={7}
                                disabled={userRole === 'qreviewer' && record?.second_reviewer_id === user?.id}
                                placeholder="Reviewer Comments"
                              />

                              {/* <Input placeholder="Reviewer Comments" /> */}
                            </Form.Item>
                          </Col>
                        )}
                        {userRole === 'qapprover' && (
                          <Col lg={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'approver_comments']}
                              rules={[{ required: false, message: 'Missing Option Comments' }]}
                            >
                              <TextArea
                                rows={7}
                                placeholder="Approver Comments"
                                disabled={userRole === 'qapprover' && user?.id === record?.second_approver_id}
                              />
                            </Form.Item>
                          </Col>
                        )}
                        <Col lg={2}>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Col>
                      </Row>
                      // <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                      //   {optionType === 'Text' && (
                      //     <Form.Item {...restField} name={[name, 'option_text']} rules={[{ required: true, message: 'Missing Option Value' }]}>
                      //       <Input placeholder="Option Text" type="small" />
                      //     </Form.Item>
                      //   )}
                      //   {optionType === 'Image' && (
                      //     <Form.Item {...restField} name={[name, 'option_image_id']} rules={[{ required: false, message: 'Missing Option Image' }]}>
                      //       <Upload
                      //         onRemove={file => {
                      //           let newFileList = { ...fileList }
                      //           newFileList[key] = []
                      //           setFileList(newFileList)
                      //         }}
                      //         beforeUpload={file => {
                      //           let newFileList = { ...fileList }
                      //           newFileList[key] = [file]
                      //           setFileList(newFileList)
                      //           return false
                      //         }}
                      //         fileList={fileList[key] ?? []}
                      //         maxCount={1}
                      //       >
                      //         <Button icon={<UploadOutlined />}>Upload New Image</Button>
                      //       </Upload>
                      //       {record?.option_details?.length > 0 &&
                      //         record?.option_details[key]?.option_image_name &&
                      //         `Uploaded file name: ${record.option_details[key]?.option_image_name}`}
                      //     </Form.Item>
                      //   )}
                      //   <Form.Item {...restField} name={[name, 'option_flag']} rules={[{ required: true, message: 'Missing Option Flag' }]}>
                      //     <Select
                      //       options={[
                      //         { label: 'Right Answer', value: 'Right Answer' },
                      //         { label: 'Most Wrong', value: 'Most Wrong' },
                      //         { label: 'Close to Correct', value: 'Close to Correct' },
                      //       ]}
                      //       placeholder="Option Flag"
                      //       style={{ width: 150 }}
                      //     />
                      //   </Form.Item>{' '}
                      //   <Form.Item {...restField} name={[name, 'option_insight']} rules={[{ required: false }]}>
                      //     <Input placeholder="Option Insight" type="small" />
                      //   </Form.Item>
                      //   {userRole === 'qreviewer' && (
                      //     <Form.Item
                      //       {...restField}
                      //       name={[name, 'reviewer_comments']}
                      //       rules={[{ required: false, message: 'Missing Option Comments' }]}
                      //     >
                      //       <Input placeholder="Reviewer Comments" />
                      //     </Form.Item>
                      //   )}
                      //   {userRole === 'qapprover' && (
                      //     <Form.Item
                      //       {...restField}
                      //       name={[name, 'approver_comments']}
                      //       rules={[{ required: false, message: 'Missing Option Comments' }]}
                      //     >
                      //       <Input placeholder="Approver Comments" />
                      //     </Form.Item>
                      //   )}
                      //   <MinusCircleOutlined
                      //     onClick={() => {
                      //       let tempFileList = { ...fileList }
                      //       delete tempFileList[key]

                      //       setFileList(tempFileList)
                      //       remove(name)
                      //     }}
                      //   />
                      // </Space>
                    )
                  })}

                  <Form.Item>
                    <Button
                      disabled={
                        (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                        (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                      }
                      type="dashed"
                      onClick={() => {
                        add()
                      }}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add Option
                    </Button>
                  </Form.Item>
                </>
              )
            }}
          </Form.List>
        )}

        {errorOption === true ? <Typography.Text type="danger">Select atleast one Right Answer </Typography.Text> : null}
        {questionType === 'Fill' && (
          <Form.List name="option_details">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <Row gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                    <Col lg={12}>
                      <Form.Item
                        {...restField}
                        label="Right Answer"
                        name={[name, 'right_answer']}
                        rules={[{ required: true, message: 'Missing Option Answer' }]}
                      >
                        {/* <TextArea
                          disabled={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          rows={4}
                          placeholder="Right Answer"
                        /> */}

                        {/* ------------------TINCY_MCE TEXT EDITOR----------------- */}

                        {/* <RichTextEditor
                          id={`edit_option_details_fill_right_answer${name}`}
                          key={key}
                          hideToolBarAndMenu={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          initialValue={record?.option_details?.[key]?.['right_answer'] ?? ''}
                          formValueSetterFn={content => {
                            handleSetFormList(content, key, 'right_answer', index)
                          }}
                        /> */}
                        {/*-------------------- SUN_TEXT_EDITOR------------------- */}
                        <SunTextEditor
                          id={`edit_option_details_fill_right_answer${name}`}
                          key={key}
                          hideToolBar={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          initialValue={record?.option_details?.[key]?.['right_answer'] ?? ''}
                          formValueSetterFn={content => {
                            handleSetFormList(content, key, 'right_answer', index)
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={10}>
                      <Form.Item {...restField} label="Option Insights" name={[name, 'option_insights']} rules={[{ required: false }]}>
                        {/* <TextArea
                          disabled={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          rows={4}
                          placeholder="Option Insight"
                        /> */}
                        <>
                          {/* ------------------TINCY_MCE TEXT EDITOR----------------- */}
                          {/* <RichTextEditor
                            id={`${name}option_text`}
                            // key={key}
                            hideToolBarAndMenu={
                              (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                              (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                            }
                            initialValue={record?.option_details?.[key]?.['option_insight'] ?? ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'option_insight', index)
                            }}
                          /> */}
                          {/*-------------------- SUN_TEXT_EDITOR------------------- */}
                          <SunTextEditor
                            id={`${name}option_text`}
                            key={key}
                            hideToolBar={
                              (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                              (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                            }
                            initialValue={record?.option_details?.[key]?.['option_insights'] ?? ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'option_insights', index)
                            }}
                          />
                        </>
                      </Form.Item>
                    </Col>
                    {userRole === 'qreviewer' && (
                      <Col lg={4}>
                        <Form.Item
                          {...restField}
                          name={[name, 'reviewer_comments']}
                          rules={[{ required: false, message: 'Missing Option Comments' }]}
                        >
                          <TextArea
                            disabled={userRole === 'qreviewer' && record?.second_reviewer_id === user?.id}
                            rows={7}
                            placeholder="Reviewer Comments"
                          />

                          {/* <Input placeholder="Reviewer Comments" /> */}
                        </Form.Item>
                      </Col>
                    )}
                    {userRole === 'qapprover' && (
                      <Col lg={4}>
                        <Form.Item
                          {...restField}
                          name={[name, 'approver_comments']}
                          rules={[{ required: false, message: 'Missing Option Comments' }]}
                        >
                          <TextArea
                            disabled={userRole === 'qapprover' && user?.id === record?.second_approver_id}
                            rows={7}
                            placeholder="Approver Comments"
                          />
                        </Form.Item>
                      </Col>
                    )}
                    <Col lg={1}>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Col>
                  </Row>
                  // <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  //   <Form.Item {...restField} name={[name, 'right_answer']} rules={[{ required: true, message: 'Missing Option Answer' }]}>
                  //     <Input placeholder="Right Answer" type="small" style={{ minWidth: 300 }} />
                  //   </Form.Item>
                  //   <Form.Item {...restField} name={[name, 'option_insights']} rules={[{ required: false }]}>
                  //     <Input placeholder="Option Insight" type="small" />
                  //   </Form.Item>
                  //   {userRole === 'qreviewer' && (
                  //     <Form.Item {...restField} name={[name, 'reviewer_comments']} rules={[{ required: false, message: 'Missing Option Comments' }]}>
                  //       <Input placeholder="Reviewer Comments" />
                  //     </Form.Item>
                  //   )}
                  //   {userRole === 'qapprover' && (
                  //     <Form.Item {...restField} name={[name, 'approver_comments']} rules={[{ required: false, message: 'Missing Option Comments' }]}>
                  //       <Input placeholder="Approver Comments" />
                  //     </Form.Item>
                  //   )}
                  //   <MinusCircleOutlined onClick={() => remove(name)} />
                  // </Space>
                ))}
                <Form.Item>
                  <Button
                    disabled={
                      (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                      (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                    }
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Option
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        )}
        {questionType === 'Match' && (
          <Form.List name="option_details">
            {(fields, { add, remove }, index) => (
              <>
                {fields.map(({ key, name, ...restField }, index) => (
                  <Row gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                    <Col lg={8}>
                      <Form.Item
                        {...restField}
                        label="Left Label"
                        name={[name, 'left_label_text']}
                        rules={[{ required: true, message: 'Missing Section' }]}
                      >
                        {/* <ReactMde
                          readOnly={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          selectedTab={selectedOptionTab?.includes('match_left_' + key) ? 'preview' : 'write'}
                          onTabChange={(value: any) => handleOptionTabChange(value, 'match_left_' + key)}
                          maxEditorHeight={75}
                          onChange={value => handleValueChange(value, key)}
                          generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                          toolbarCommands={ReactMdeToolbarCommands}
                          paste={{
                            saveImage: saveOptions,
                          }}
                        /> */}
                        <>
                          {/* ------------------TINCY_MCE TEXT EDITOR----------------- */}
                          {/* <RichTextEditor
                            id={`${name}left_label_text`}
                            hideToolBarAndMenu={
                              (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                              (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                            }
                            initialValue={record?.option_details?.[key]?.['left_label_text'] ?? ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'left_label_text', index)
                            }}
                            // handleImageUpload={handleImageUplodFromEditor}
                          /> */}
                          {/*-------------------- SUN_TEXT_EDITOR------------------- */}
                          <SunTextEditor
                            id={`${name}left_label_text`}
                            key={key}
                            hideToolBar={
                              (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                              (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                            }
                            initialValue={record?.option_details?.[key]?.['left_label_text'] ?? ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'left_label_text', index)
                            }}
                          />
                        </>
                      </Form.Item>
                    </Col>
                    <Col lg={8}>
                      <Form.Item
                        {...restField}
                        label="Right Label"
                        name={[name, 'right_label_text']}
                        rules={[{ required: true, message: 'Missing Section' }]}
                      >
                        {/* <ReactMde
                          readOnly={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          selectedTab={selectedOptionTab?.includes('match_right_' + key) ? 'preview' : 'write'}
                          onTabChange={(value: any) => handleOptionTabChange(value, 'match_right_' + key)}
                          maxEditorHeight={75}
                          onChange={value => handleValueChange(value, key)}
                          generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                          toolbarCommands={ReactMdeToolbarCommands}
                          paste={{
                            saveImage: saveOptions,
                          }}
                        /> */}
                        <>
                          {/* ------------------TINCY_MCE TEXT EDITOR----------------- */}
                          {/* <RichTextEditor
                            id={`${name}right_label_text`}
                            hideToolBarAndMenu={
                              (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                              (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                            }
                            initialValue={record?.option_details?.[key]?.['right_label_text'] ?? ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'right_label_text', index)
                            }}
                          /> */}
                          {/*-------------------- SUN_TEXT_EDITOR------------------- */}
                          <SunTextEditor
                            id={`${name}right_label_text`}
                            key={key}
                            hideToolBar={
                              (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                              (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                            }
                            initialValue={record?.option_details?.[key]?.['right_label_text'] ?? ''}
                            formValueSetterFn={(content: string) => {
                              handleSetFormList(content, key, 'right_label_text', index)
                            }}
                          />
                        </>
                      </Form.Item>
                    </Col>
                    <Col lg={7}>
                      <Form.Item {...restField} label="Option Insight" name={[name, 'option_insight']} rules={[{ required: false }]}>
                        {/* ------------------TINCY_MCE TEXT EDITOR----------------- */}
                        {/* <RichTextEditor
                          id={`${name}option_insight`}
                          key={key}
                          hideToolBarAndMenu={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          initialValue={record?.option_details?.[key]?.['option_insight'] ?? ''}
                          formValueSetterFn={(content: string) => {
                            handleSetFormList(content, key, 'option_insight', index)
                          }}
                          // handleImageUpload={handleImageUplodFromEditor}
                        /> */}
                        {/*-------------------- SUN_TEXT_EDITOR------------------- */}
                        <SunTextEditor
                          id={`${name}option_insight`}
                          key={key}
                          hideToolBar={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          initialValue={record?.option_details?.[key]?.['option_insight'] ?? ''}
                          formValueSetterFn={(content: string) => {
                            handleSetFormList(content, key, 'option_insight', index)
                          }}
                        />
                      </Form.Item>
                    </Col>
                    {userRole === 'qreviewer' && (
                      <Col lg={3}>
                        <Form.Item
                          {...restField}
                          name={[name, 'reviewer_comments']}
                          rules={[{ required: false, message: 'Missing Option Comments' }]}
                        >
                          <TextArea
                            disabled={userRole === 'qreviewer' && record?.second_reviewer_id === user?.id}
                            rows={7}
                            placeholder="Reviewer Comments"
                          />

                          {/* <Input placeholder="Reviewer Comments" /> */}
                        </Form.Item>
                      </Col>
                    )}
                    {userRole === 'qapprover' && (
                      <Col lg={3}>
                        <Form.Item
                          {...restField}
                          name={[name, 'approver_comments']}
                          rules={[{ required: false, message: 'Missing Option Comments' }]}
                        >
                          <TextArea
                            rows={7}
                            placeholder="Approver Comments"
                            disabled={userRole === 'qapprover' && user?.id === record?.second_approver_id}
                          />
                        </Form.Item>
                      </Col>
                    )}
                    <Col lg={1}>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Col>
                  </Row>
                  // <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                  //   {optionType === 'Text' && (
                  //     <>
                  //       <Form.Item {...restField} name={[name, 'left_label_text']} rules={[{ required: true, message: 'Missing Section' }]}>
                  //         <Input placeholder="Left Label" type="small" />
                  //       </Form.Item>
                  //       <Form.Item {...restField} name={[name, 'right_label_text']} rules={[{ required: true, message: 'Missing Section' }]}>
                  //         <Input placeholder="Right Label" type="small" />
                  //       </Form.Item>
                  //     </>
                  //   )}
                  //   {optionType === 'Image' && (
                  //     <>
                  //       <Form.Item {...restField} name={[name, 'left_label_image']} rules={[{ required: true, message: 'Missing Section' }]}>
                  //         {/* <Upload {...uploadprops}>
                  //           <Button icon={<UploadOutlined />}>Left Label Image</Button>
                  //         </Upload> */}
                  //       </Form.Item>
                  //       <Form.Item {...restField} name={[name, 'right_label_image']} rules={[{ required: true, message: 'Missing Section' }]}>
                  //         {/* <Upload {...uploadprops}>
                  //           <Button icon={<UploadOutlined />}>Right Label Image</Button>
                  //         </Upload> */}
                  //       </Form.Item>
                  //     </>
                  //   )}
                  //   <Form.Item {...restField} name={[name, 'option_insight']} rules={[{ required: false }]}>
                  //     <Input placeholder="Option Insight" type="small" />
                  //   </Form.Item>
                  //   {userRole === 'qreviewer' && (
                  //     <Form.Item {...restField} name={[name, 'reviewer_comments']} rules={[{ required: false, message: 'Missing Option Comments' }]}>
                  //       <Input placeholder="Reviewer Comments" />
                  //     </Form.Item>
                  //   )}
                  //   {userRole === 'qapprover' && (
                  //     <Form.Item {...restField} name={[name, 'approver_comments']} rules={[{ required: false, message: 'Missing Option Comments' }]}>
                  //       <Input placeholder="Approver Comments" />
                  //     </Form.Item>
                  //   )}
                  //   <MinusCircleOutlined onClick={() => remove(name)} />
                  // </Space>
                ))}
                <Form.Item>
                  <Button
                    disabled={
                      (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                      (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                    }
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Option
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        )}
        {questionType === 'ShortAnswer' && (
          <Form.List
            initialValue={[
              { component_name: '', rating_1: '', rating_2: '', rating_3: '', rating_4: '', weightage: '' },
              { component_name: '', rating_1: '', rating_2: '', rating_3: '', rating_4: '', weightage: '' },
              { component_name: '', rating_1: '', rating_2: '', rating_3: '', rating_4: '', weightage: '' },
            ]}
            rules={[
              {
                validator: async (_, names) => {
                  if (names?.length >= 8) {
                    return Promise.reject(new Error('Exceeded maximum rubric field. (Max is 7)'))
                  }
                },
              },
            ]}
            name="option_details"
          >
            {(fields, { add, remove }, { errors }) => {
              return (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                      <Form.Item {...restField} name={[name, 'component_name']} rules={[{ required: true, message: 'Missing Section' }]}>
                        <Input
                          disabled={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          placeholder="Component Name"
                          type="small"
                        />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_1']} rules={[{ required: true, message: 'Missing Rating 1' }]}>
                        <Input
                          disabled={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          placeholder="Rating 1"
                          type="small"
                        />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_2']} rules={[{ required: true, message: 'Missing Rating 2' }]}>
                        <Input
                          disabled={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          placeholder="Rating 2"
                          type="small"
                        />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_3']} rules={[{ required: true, message: 'Missing Rating 3' }]}>
                        <Input
                          disabled={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          placeholder="Rating 3"
                          type="small"
                        />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_4']} rules={[{ required: true, message: 'Missing Rating 4' }]}>
                        <Input
                          disabled={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          placeholder="Rating 4"
                          type="small"
                        />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'weightage']} rules={[{ required: true, message: 'Missing Weightage' }]}>
                        <Input
                          disabled={
                            (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                            (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                          }
                          placeholder="Weightage"
                          type="small"
                          style={{ maxWidth: 150 }}
                        />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <Button
                      disabled={
                        (userRole === 'qreviewer' && record?.second_reviewer_id === user?.id) ||
                        (userRole === 'qapprover' && user?.id === record?.second_approver_id)
                      }
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add Option
                    </Button>
                  </Form.Item>
                  <Form.ErrorList errors={errors} />
                </>
              )
            }}
          </Form.List>
        )}

        {userRole === 'qreviewer' && record?.second_reviewer_id !== user?.id ? (
          <>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Second Reviewer
            </Divider>
            <Row gutter={[16, 0]}>
              <Col xs={24} lg={24}>
                <Form.Item name="second_reviewer_id" rules={[{ required: secondReviewMandatory }]}>
                  <Select
                    style={{ width: '100%' }}
                    onChange={(value: any) => setSeconReviewerName(value)}
                    placeholder="Select Second Reviewer"
                    allowClear
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                      option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {qreviewerList?.length > 0 &&
                      qreviewerList?.map(item =>
                        item?.id !== user?.id ? (
                          <option key={item?.id} value={item?.id}>
                            {item?.displayName}
                          </option>
                        ) : null
                      )}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </>
        ) : null}
        {/* {console.log({secondApproverName})} */}
        {userRole === 'qapprover' && record?.second_approver_id !== user?.id ? (
          <>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Second Approver
            </Divider>
            <Row gutter={[16, 0]}>
              <Col xs={24} lg={24}>
                <Form.Item name="second_approver_id" rules={[{ required: secondApprovalMandatory, message: 'Please input your nickname' }]}>
                  <Select
                    style={{ width: '100%' }}
                    onChange={(value: any) => setSeconApproverName(value)}
                    placeholder="Select Second Approver"
                    allowClear
                    showSearch
                    filterOption={(input: any, option: any) =>
                      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                      option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {qapproverList?.length > 0 &&
                      qapproverList?.map(item =>
                        item?.id !== user?.id ? (
                          <option key={item?.id} value={item?.id}>
                            {item?.displayName}
                          </option>
                        ) : null
                      )}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </>
        ) : null}
        <Divider />
        <Row gutter={[16, 0]} justify="end" align="top">
          <Col xs={24} lg={8} style={{ display: 'flex', justifyContent: 'end' }}>
            <Space>
              <Button
                onClick={() => {
                  formProps?.form?.resetFields()
                  setFileList([])
                  close()
                }}
              >
                Cancel
              </Button>
              {((workRequestRecord?.data?.request_type === 'Q' && userRole === 'qcreator') ||
                (workRequestRecord?.data?.request_type === 'V' && userRole === 'variantcreator')) && (
                <Button
                  htmlType="button"
                  onClick={() => {
                    handleOnFinish('For Review')
                  }}
                  disabled={(questionStatus !== 'Open' && questionStatus !== 'Open (Require Amending)') || reviewers?.length < 1}
                >
                  Submit for Review
                </Button>
              )}
              {userRole === 'qreviewer' && (
                <>
                  {user?.id === record?.reviewer_id ? (
                    <Button
                      htmlType="button"
                      onClick={() => {
                        handleOnFinish('For Second Review')
                      }}
                      hidden={(record?.status === 'For Second Review' && user?.id === record?.second_reviewer_id) || record?.status !== 'For Review'}
                      disabled={
                        questionStatus !== 'For Review' &&
                        questionStatus !== 'For Review (Require Amending)' &&
                        questionStatus !== 'For Second Review' &&
                        secondReviewerName === ''
                      }
                    >
                      Second Review
                    </Button>
                  ) : null}
                  {user?.id === record?.second_reviewer_id && record?.status === 'For Second Review' ? (
                    <Button
                      htmlType="button"
                      onClick={() => {
                        handleSendBack('For Review', 'reviewer')
                      }}
                      disabled={
                        questionStatus !== 'For Review' &&
                        questionStatus !== 'For Review (Require Amending)' &&
                        questionStatus !== 'For Second Review'
                      }
                    >
                      Send Back to R1
                    </Button>
                  ) : null}
                  <Button
                    htmlType="button"
                    onClick={() => {
                      handleOnFinish('Rejected at Review')
                    }}
                    disabled={questionStatus !== 'For Review' && questionStatus !== 'For Review (Require Amending)'}
                  >
                    Reject
                  </Button>

                  <Button
                    htmlType="button"
                    onClick={() => {
                      handleOnFinish('Open (Require Amending)')
                    }}
                    hidden={questionStatus === 'For Review (Require Amending)' || questionStatus === 'For Approval' || questionStatus === 'Published'}
                    disabled={questionStatus !== 'For Review' && questionStatus !== 'For Review (Require Amending)'}
                  >
                    Require Amending
                  </Button>
                  {/* {} */}
                  {console.log(
                    'conditionxxx',
                    approvers?.length < 1 && (questionStatus === 'For Review' || questionStatus == 'For Review (Require Amending') ? true : false,
                    approvers
                  )}
                  <Button
                    htmlType="button"
                    onClick={() => {
                      handleOnFinish('For Approval')
                    }}
                    disabled={
                      approvers?.length > 0 && (questionStatus === 'For Review' || questionStatus === 'For Review (Require Amending)') ? false : true
                    }
                    // questionStatus !== 'For Review' && questionStatus !== 'For Review (Require Amending)' && approvers?.length < 1
                    // workRequestRecord?.data?.workRequestApprovers?.length < 1
                  >
                    Submit for Approval
                  </Button>
                </>
              )}
              {userRole === 'qapprover' && (
                <>
                  {user?.id === record?.approver_id ? (
                    <Button
                      htmlType="button"
                      onClick={() => {
                        handleOnFinish('For Second Approval')
                      }}
                      hidden={
                        (record?.status === 'For Second Approval' && user?.id === record?.second_approver_id) || record?.status !== 'For Approval'
                      }
                      disabled={questionStatus !== 'For Approval' || secondApproverName === ''}
                    >
                      Second Approval
                    </Button>
                  ) : null}
                  {user?.id === record?.second_approver_id && record?.status === 'For Second Approval' ? (
                    <Button
                      htmlType="button"
                      onClick={() => {
                        handleSendBack('For Approval', 'approver')
                      }}
                      disabled={questionStatus !== 'For Second Approval'}
                    >
                      Send Back to A1
                    </Button>
                  ) : null}
                  <Button
                    htmlType="button"
                    onClick={() => {
                      handleOnFinish('Rejected at Approval')
                    }}
                    disabled={questionStatus !== 'For Approval'}
                  >
                    Reject
                  </Button>
                  <Button
                    htmlType="button"
                    onClick={() => {
                      handleOnFinish('For Review (Require Amending)')
                    }}
                    disabled={questionStatus !== 'For Approval'}
                  >
                    Require Amending
                  </Button>
                  <Button
                    htmlType="button"
                    onClick={() => {
                      handleOnFinish('Published')
                    }}
                    disabled={questionStatus !== 'For Approval'}
                  >
                    Approve
                  </Button>
                </>
              )}
              <Button type="primary" htmlType="button" onClick={() => formProps?.form?.submit()}>
                Save
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}